import { render, staticRenderFns } from "./employment.vue?vue&type=template&id=0b82a158&scoped=true"
import script from "./employment.vue?vue&type=script&lang=js"
export * from "./employment.vue?vue&type=script&lang=js"
import style0 from "./employment.vue?vue&type=style&index=0&id=0b82a158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b82a158",
  null
  
)

export default component.exports